const idCoefficients = [2, 1, 2, 1, 2, 1, 2, 1, 2];
const legalPersonRUCCoefficients = [4, 3, 2, 7, 6, 5, 4, 3, 2];
const publicCompanyRUCCoefficients = [3, 2, 7, 6, 5, 4, 3, 2];
const validateCI = (document) => {
  if (validateProvince(document.substring(0, 2)) && isIDNaturalPerson(document) && validateID(document, idCoefficients)) {
    return;
  }
  return "C\xE9dula de identidad inv\xE1lida";
};
const validateRUC = (document) => {
  const validateNaturalRUC = isRUCNaturalPerson(document) && validateID(document, idCoefficients);
  const validateLegalRUC = isRUCLegalPerson(document) && validateRUCByCoefficients(
    document,
    legalPersonRUCCoefficients,
    document.charAt(9)
  );
  const validateCompanyRUC = isRUCLegalCompany(document) && validateRUCByCoefficients(
    document,
    publicCompanyRUCCoefficients,
    document.charAt(8)
  );
  if (validateNaturalRUC || validateLegalRUC || validateCompanyRUC)
    return;
  return "RUC inv\xE1lido";
};
const validateCI_CO = (document) => {
  if (/^\d{6,11}$/.test(document))
    return;
  return "C\xE9dula de ciudadan\xEDa inv\xE1lida";
};
const validateCE = (document) => {
  if (/^\d{5,7}$/.test(document))
    return;
  return "Cedula de extranjer\xEDa inv\xE1lida";
};
const validateNIT = (document) => {
  if (/^\d{7,10}$/.test(document))
    return;
  return "NIT inv\xE1lido";
};
const validatePassport = (document) => {
  if (document.length > 20)
    return "Pasaporte inv\xE1lido";
};
const validateRut = (document) => {
  if (document.length <= 20)
    return "RUT inv\xE1lido";
};
const isIDNaturalPerson = (identification) => {
  return identification.length === 10;
};
const isRUCNaturalPerson = (identification) => {
  return identification.length === 13 && identification.charAt(2) !== "6" && identification.charAt(2) !== "9" && identification.substring(10, 13) === "001";
};
const lastRUCDigits = (identification) => {
  return identification.length === 13 && identification.substring(10, 13) === "001";
};
const isRUCLegalPerson = (identification) => {
  return lastRUCDigits(identification) && identification.charAt(2) === "9";
};
const isRUCLegalCompany = (identification) => {
  return lastRUCDigits(identification) && identification.charAt(2) === "6";
};
const validateID = (identification, coefficients) => {
  const id = identification;
  let addDigitsByCoefficient = 0;
  let value = 0;
  for (let i = 0; i < coefficients.length; i++) {
    const digit = Number(id.charAt(i)) * 1;
    value = coefficients[i] * digit;
    if (value > 9) {
      value = value - 9;
    }
    addDigitsByCoefficient = addDigitsByCoefficient + value;
  }
  let module = addDigitsByCoefficient % 10;
  module = module === 0 ? 10 : module;
  const result = 10 - module;
  const lastDigit = Number(id.charAt(9)) * 1;
  return result === lastDigit;
};
const validateRUCByCoefficients = (identification, coefficients, checkDigit) => {
  const id = identification;
  const verifier = Number(checkDigit) * 1;
  let addTotalsDigitsByCoefficient = 0;
  let digit = 0;
  let value = 0;
  for (let i = 0; i < coefficients.length; i++) {
    digit = Number(id.charAt(i)) * 1;
    value = coefficients[i] * digit;
    addTotalsDigitsByCoefficient = addTotalsDigitsByCoefficient + value;
  }
  const module = addTotalsDigitsByCoefficient % 11;
  let result = 0;
  if (module !== 0) {
    result = 11 - module;
  }
  return result === verifier;
};
const validateProvince = (identification) => {
  return parseInt(identification) <= 0 || parseInt(identification) > 24;
};
const validateCODocuments = (documentType, value) => {
  switch (documentType) {
    case "PASSPORT":
      return validatePassport(value);
    case "RUT":
      return validateRut(value);
    case "NIT":
      return validateNIT(value);
    case "CE":
      return validateCE(value);
    case "CC":
      return validateCI_CO(value);
    default:
      console.error(
        "DocumentInput: The type of document entered is invalid for the selected country."
      );
      return "DocumentInput: The type of document entered is invalid for the selected country.";
  }
};
const validateECDocuments = (documentType, value) => {
  switch (documentType) {
    case "PASSPORT":
      validatePassport(value);
      break;
    case "CI":
      return validateCI(value);
    case "RUC":
      return validateRUC(value);
    default:
      console.error(
        "DocumentInput: The type of document entered is invalid for the selected country."
      );
      return "DocumentInput: The type of document entered is invalid for the selected country.";
  }
};
const validateDocument = (countryCode, documentType, value) => {
  switch (countryCode) {
    case "AR":
      return validatePassport(value);
    case "BO":
      return validatePassport(value);
    case "BR":
      return validatePassport(value);
    case "CL":
      return validatePassport(value);
    case "CO":
      return validateCODocuments(documentType, value);
    case "EC":
      return validateECDocuments(documentType, value);
    case "PY":
      return validatePassport(value);
    case "PE":
      return validatePassport(value);
    case "UY":
      return validatePassport(value);
    case "VE":
      return validatePassport(value);
    case "US":
      return validatePassport(value);
    default:
      console.error(
        "DocumentInput: The country code entered is not currently supported."
      );
      return "DocumentInput: The country code entered is not currently supported.";
  }
};

export { validateCE, validateCI, validateCI_CO, validateDocument, validateNIT, validatePassport, validateRUC, validateRut };
//# sourceMappingURL=bundle.esm3.js.map
